// @flow
export const filterId: 'year' = 'year';
